/** Append appointmentId to a path as a query param (preserves existing query). */
export function withAppointmentIdQuery(
  path: string,
  appointmentId?: string | null
): string {
  const id = String(appointmentId ?? "").trim();
  if (!id) return path;
  const [base, existing = ""] = path.split("?");
  const params = new URLSearchParams(existing);
  params.set("appointmentId", id);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export function readAppointmentIdFromSearch(
  searchParams: URLSearchParams | { get: (k: string) => string | null }
): string | null {
  const id = String(searchParams.get("appointmentId") ?? "").trim();
  return id || null;
}

export function appointmentIdPayload(appointmentId?: string | null): {
  appointmentId?: string;
} {
  const id = String(appointmentId ?? "").trim();
  return id ? { appointmentId: id } : {};
}

/**
 * Commit the visit context onto a sheet as soon as it is opened with
 * ?appointmentId=… (treatment table, invoice page). Opening used to link
 * nothing; only writes did, so a multi-visit sheet where staff merely flipped
 * a stage to Complete and paid from another screen kept pointing at the
 * first visit. Fire-and-forget: failures must never block the page.
 */
export async function linkAppointmentOnOpen(
  http: { post: (url: string, body: unknown) => Promise<unknown> },
  treatmentId?: string | null,
  appointmentId?: string | null
): Promise<void> {
  const tId = String(treatmentId ?? "").trim();
  const aId = String(appointmentId ?? "").trim();
  if (!tId || !aId) return;
  try {
    await http.post("treatment/link-appointment", {
      treatmentId: tId,
      appointmentId: aId,
    });
  } catch (error) {
    console.error("link-appointment on open failed", error);
  }
}
